// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-video-container[data-v-26233731]{max-width:600px;min-width:600px}.my_divider[data-v-26233731]{border:3px solid;border-radius:2px;max-width:5rem}@media (max-width:600px){.my-video-container[data-v-26233731]{max-width:350px;min-width:350px}}@media (min-width:960px) and (max-width:1264px){.my-video-container[data-v-26233731]{max-width:800px;min-width:800px}}", ""]);
// Exports
module.exports = exports;
